import { Modal } from "antd";
import "./model.css";

// pass open = true/false, onOk = (handleClickOkButton), onCancel = (handleOnCancelBtn) and title (string)
const MyModal = ({ children, ...rest }) => {
  return <Modal {...rest}>{children}</Modal>;
};

export default MyModal;
